module.exports = __webpack_public_path__ + "static/img/president1.c56feed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/president1.png
// module id = 512
// module chunks = 1